(function () {
var dateBody = document.querySelector(".date_picker_body");
var minDate = preOrderDate ? new Date(preOrderDate) : new Date();
if(minDate < new Date()){
    minDate = new Date();
}
function openDate() {
    if (dateBody.style.height === '0px' || dateBody.style.height === '') {
        dateBody.style.display = 'block';
        dateBody.style.height = dateBody.scrollHeight + 'px';
    } else {
        dateBody.style.height = '0px';
        setTimeout(() => {
            dateBody.style.display = 'none';
        }, 250);
    }
}

function adjustDateBodyHeight() {
    if (dateBody.style.display === 'block') {
        dateBody.style.height = 'auto'; 
        let height = dateBody.scrollHeight + 'px';
        dateBody.style.height = height;
    }
}
function handleClickOutside(event) {
    var datePickerWrapper = document.querySelector("#date_picker_1");
    if (dateBody.style.display === 'block' && !datePickerWrapper.contains(event.target)) {
        openDate(); 
    }
}
window.addEventListener('resize', adjustDateBodyHeight);
document.addEventListener('click', handleClickOutside);

var dateInput = document.getElementById("date_input");
if (dateInput) {
  var year = minDate.getFullYear();
  var month = String(minDate.getMonth() + 1).padStart(2, '0');
  var day = String(minDate.getDate()).padStart(2, '0');
  dateInput.value = `${year}-${month}-${day}`;
}

const CONSTANTS = {
    DOM_SELECTORS: {
        datePicker: "",
        datePickerPrevMonth: ".date_picker_prev_month",
        datePickerNextMonth: ".date_picker_next_month",
        datePickerMonthDays: ".date_picker_month_days",
        datePickerMonthDay: ".date_picker_month_day",
        datePickerMonthDay2: "input",
        datePickerYear: ".date_picker_year",
        datePickerMonthName: ".date_picker_month_name",
        datePickerDay: ".day"
    },
    DOM_STRINGS: {
        dataTime: "li[data-time]"
    },
    DUMMY_LI_FOR_EMPTY_DAYS: '<li class="day"></li>',
    DAY_MAP: {
        0: "Sunday",
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday"
    },
    MONTH_MAP: {
        0: "January",
        1: "February",
        2: "March",
        3: "April",
        4: "May",
        5: "June",
        6: "July",
        7: "August",
        8: "September",
        9: "October",
        10: "November",
        11: "December"
    }
};

const utils = (function () {
    function prefixDOMSelectorsWithPickerSelector(pickerSelector) {
        let DOM_SELECTORS = {};
        for (let selector in CONSTANTS.DOM_SELECTORS) {
            DOM_SELECTORS[
                selector
            ] = `${pickerSelector} ${CONSTANTS.DOM_SELECTORS[selector]}`.trim();
        }
        CONSTANTS.DOM_SELECTORS = DOM_SELECTORS;
    }

    function getDOMElements(DOMSelectors) {
        let DOMElements = {};
        for (let selector in DOMSelectors) {
            if (DOMSelectors.hasOwnProperty(selector)) {
                DOMElements[selector] = document.querySelector(DOMSelectors[selector]);
            }
        }
        return DOMElements;
    }

    function getDatePickerWeekDaysNameMarkUp() {
        return `
            <li>Sunday</li>
            <li>Monday</li>
            <li>Tuesday</li>
            <li>Wednesday</li>
            <li>Thursday</li>
            <li>Friday</li>
            <li>Saturday</li>`;
    }

    function getDayMarkup(day = 1, isActive = false, time = null) {
        let selectedDate = new Date(time).getDate();
        let currentMonth = new Date().getMonth();
        let selectedMonth = new Date(time).getMonth();
        if (!time) {
            console.trace(`The time provided for getDayMarkup ${time} is invalid`);
        }
        if (time < minDate.getTime()) {
            if (minDate === selectedDate && currentMonth === selectedMonth) {
                return `<li class="day" data-time="${time}">
                      <button class="${isActive ? "active" : ""}">${day}</button>
                  </li>`;
            } else {
                return `<li class="day" data-time="${time}">
                        <button class="${isActive ? "active" : "past-day"}">${day}</button>
                    </li>`;
            }
        } else {
            return `<li class="day" data-time="${time}">
                      <button class="${isActive ? "active" : ""}">${day}</button>
                  </li>`;
        }
    }

    function getAllDays() {
        let days = document.querySelectorAll(CONSTANTS.DOM_SELECTORS.datePickerDay);
        return [...(days ?? [])];
    }

    function getDaySuffix(day) {
        switch (day) {
            case 1:
            case 21:
            case 31:
                return "st";
            case 2:
            case 22:
                return "nd";
            case 3:
            case 23:
                return "rd";
            default:
                return "th";
        }
    }

    return {
        prefixDOMSelectorsWithPickerSelector,
        getDOMElements,
        getDatePickerWeekDaysNameMarkUp,
        getDayMarkup,
        getAllDays,
        getDaySuffix
    };
})();

const model = (function () {
    const data = {
        currentDate: new Date(),
        selectedDate: new Date()
    };

    function setCurrentDate(newDate) {
        data.currentDate = newDate;
    }

    function setSelectedDate(newDate) {
        data.selectedDate = newDate;
    }

    function getCurrentDate() {
        return data.currentDate;
    }

    function getSelectedDate() {
        return data.selectedDate;
    }

    return { setCurrentDate, setSelectedDate, getCurrentDate, getSelectedDate };
})();

const view = (function (model, utils) {
    function removeDays() {
        const allDays = utils.getAllDays();
        allDays.forEach((day) => day.remove());
    }

    function fillEmptyDays(count) {
        const DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
        for (let i = 0; i < count; i++) {
            DOMElements.datePickerMonthDays.insertAdjacentHTML(
                "beforeend",
                CONSTANTS.DUMMY_LI_FOR_EMPTY_DAYS
            );
        }
    }

    function fillDay(day, isActive = false, time) {
        const dayMarkUp = utils.getDayMarkup(day, isActive, time);
        const DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
        DOMElements.datePickerMonthDays.insertAdjacentHTML("beforeend", dayMarkUp);
    }

    function fillCurrentMonth(string) {
        const DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
        DOMElements.datePickerMonthName.textContent = string;
    }

    function fillSelectedDate(month, date, day, year) {
        const DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
        DOMElements.datePickerMonthDay.innerHTML = `${CONSTANTS.DAY_MAP[day]},
        ${date}
        ${CONSTANTS.MONTH_MAP[month]},`;
        DOMElements.datePickerYear.textContent = year;
    }

    return {
        removeDays,
        fillEmptyDays,
        fillDay,
        fillCurrentMonth,
        fillSelectedDate
    };
})(model, utils);

const controller = (function (model, view, utils) {
    let DOMElements = null;

    function init(pickerSelector = "", selectedDate = new Date()) {
        utils.prefixDOMSelectorsWithPickerSelector(pickerSelector);
        DOMElements = utils.getDOMElements(CONSTANTS.DOM_SELECTORS);
        if (!DOMElements.datePicker) {
            throw new Error(
                `Date Picker with selector ${pickerSelector} not found in the document`
            );
        }
        DOMElements.datePickerNextMonth.addEventListener(
            "click",
            handleNextMonthClick
        );
        DOMElements.datePickerPrevMonth.addEventListener(
            "click",
            handlePrevMonthClick
        );
        DOMElements.datePickerMonthDays.addEventListener("click", handleSelectDate);
        if (selectedDate.constructor !== Date) {
            throw new Error(`The initial date ${selectedDate} is not a Date Object`);
        }
        let initialDate = new Date(selectedDate.getTime());
        if (initialDate < minDate) {
            initialDate = minDate;
        }
        model.setSelectedDate(new Date(initialDate.getTime()));
        model.setCurrentDate(new Date(initialDate.getTime()));
        render(initialDate);
    }

    function handleSelectDate(event) {
        const time = event.target.closest(CONSTANTS.DOM_STRINGS.dataTime)?.dataset.time;
        if (!time) return;
        var newDate = new Date(Number(time));
        if(!(newDate < minDate)){
            model.setSelectedDate(new Date(Number(time)));
            model.setCurrentDate(new Date(Number(time)));
        } else {
            model.setSelectedDate(minDate);
            model.setCurrentDate(minDate);
        }

        var day = ("0" + model.getSelectedDate().getDate()).slice(-2);
        var month = ("0" + (model.getSelectedDate().getMonth() + 1)).slice(-2);
        var today = model.getSelectedDate().getFullYear()+"-"+(month)+"-"+(day) ;
        var date_input = document.getElementById('date_input');
        if(date_input != null){
            date_input.value = today;
        }

        render();
    }

    function handleNextMonthClick() {
        render();
    }

    function handlePrevMonthClick() {
        let currentDate = new Date(model.getCurrentDate().getTime());
        currentDate.setMonth(currentDate.getMonth() - 2);
        model.setCurrentDate(currentDate);
        render();
    }

    function render(selectedDate = null) {
        updateSelectedDateMarkUp();
        view.removeDays();
        let currentDate = new Date(
            selectedDate?.getTime() ?? model.getCurrentDate().getTime()
        );
        let selected = model.getSelectedDate();
        let selectedDay = selected.getDate();
        let selectedMonth = selected.getMonth();
        let selectedYear = selected.getFullYear();
        currentDate.setDate(1);
        let renderingMonth = currentDate.getMonth();
        view.fillEmptyDays(currentDate.getDay());
        view.fillCurrentMonth(
            `${CONSTANTS.MONTH_MAP[renderingMonth]} ${currentDate.getFullYear()}`
        );
        while (currentDate.getMonth() === renderingMonth) {
            let currentMonth = currentDate.getMonth();
            let currentDay = currentDate.getDate();
            let currentYear = currentDate.getFullYear();
            let currentStringDate = `${currentDay}/${
                currentMonth + 1
            }/${currentYear}`;
            let selectedStringDate = `${selectedDay}/${
                selectedMonth + 1
            }/${selectedYear}`;
            view.fillDay(
                currentDate.getDate(),
                selectedStringDate === currentStringDate,
                currentDate.getTime()
            );
            currentDate.setDate(currentDay + 1);
        }
        model.setCurrentDate(currentDate);
        adjustDateBodyHeight(); // Adjust height after rendering
    }

    function updateSelectedDateMarkUp() {
        const currentDate = new Date(model.getSelectedDate().getTime());
        view.fillSelectedDate(
            currentDate.getMonth(),
            currentDate.getDate(),
            currentDate.getDay(),
            currentDate.getFullYear()
        );
    }

    return { init };
})(model, view, utils);

controller.init("#date_picker_1");
// adding click event to date_input 
document.querySelector('.date_picker_header').addEventListener("click", openDate);
})();